import React, { useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { pickBy, pick, get, keyBy, omit, mapValues, } from 'lodash';
import { useList, } from 'react-use';
import { addDays, } from 'date-fns';

import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { fields, itemFields, } from '../../shared/models/purchase';
import ListForm from '../ListForm';

const { entries, } = Object;

export default function PurchaseFormModal(props) {
  const { isOpen, values, products, onClickClose, } = props;
  const statedFields = useFormState(values, fields(), isOpen);
  const isNew = !values || !values.id;
  const [items, { set: setItems, updateAt: updateItemAt }] = useList(values?.items || [{}]);
  const isUnsubmittable =
    Object.values(statedFields).some(_ => !_.isValid) ||
    (items.length <= 0) ||
    (items.some(_ => !_.isValid));
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    props.onSubmit({ ...mapValues(statedFields, 'value'), items: items.map(_ => omit(_, 'isValid')), });
  };

  return (
    <Modal isOpen={isOpen} style={{ minWidth: 1200 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            仕入
          </h5>
        </div>
      </div>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <div style={{ width: 300 }}>
            <Field
              name="inboundDate"
              {...statedFields.inboundDate}
            />
          </div>
          <div className="mt-3">
            <ListForm
              addButtonLabel="項目追加"
              items={items}
              renderItem={(item, itemIndex) => {
                return (
                  <div className="card p-3">
                    <ItemForm
                      index={itemIndex}
                      values={item}
                      onChange={_ => updateItemAt(itemIndex, { ...item, ..._, })}
                      {...{ products, }}
                    />
                  </div>
                );
              }}
              onChange={setItems}
              minItems={2}
              cloneEnabled
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="cancel" color="secondary" outline onClick={onClickClose}>閉じる</Button>
          <Button className="save" type="submit" color="primary" outline onClick={onSubmit} disabled={isUnsubmittable}>保存</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

function ItemForm (props) {
  const { products, values, onChange, } = props;
  const fieldsWithImages = {
    ...itemFields({ products, }),
    productId: {
      ...itemFields({ products, }).productId,
      options: products.map(_ => {
        const imageUrl = _.amazonAttributes?.summaries?.[0]?.mainImage?.link;
        return {
          label: imageUrl ? (
            <div className="d-flex align-items-center gap-2">
              <img src={imageUrl} style={{ maxHeight: 40, maxWidth: 40 }} alt="商品画像" />
              <span>[{_.sku}] {_.name}</span>
            </div>
          ) : `[${_.sku}] ${_.name}`,
          value: _.id,
        };
      }),
    },
  };
  const statedFields = useFormState(values, fieldsWithImages, values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value)]);

  return (
    <div>
      <div className="d-flex gap-1">
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => !fieldSetting.shouldHide && (
            <div style={{ width: fieldName === 'productId' ? 400 : 150, }} key={fieldName}>
              <Field
                name={fieldName}
                {...fieldSetting}
                inputProps={{ components: { IndicatorsContainer: _ => null } }}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
}

